function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.466 9.988c.006.13.01.261.01.393 0 4.004-3.096 8.619-8.758 8.619C8.98 19 7.362 18.5 6 17.64c.241.028.486.042.734.042 1.443 0 2.77-.484 3.823-1.297a3.076 3.076 0 01-2.876-2.104 3.121 3.121 0 001.39-.051c-1.408-.278-2.468-1.502-2.468-2.97v-.039c.415.227.89.363 1.394.379a3.016 3.016 0 01-1.37-2.522c0-.556.152-1.076.417-1.524a8.784 8.784 0 006.344 3.167 2.965 2.965 0 01-.08-.691c0-1.673 1.378-3.03 3.078-3.03a3.1 3.1 0 012.246.956 6.176 6.176 0 001.955-.735 3.055 3.055 0 01-1.354 1.677A6.2 6.2 0 0021 8.421a6.132 6.132 0 01-1.534 1.567z",
  fill: "#fff"
});

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.aa5415b4.svg";
export { ForwardRef as ReactComponent };